import {digitalData,vzdl} from './digitalData';
import {PageInfo,VzdlPageInfo} from './dataObjects';
import { setPageInfo, setSaveCartInfo, formatCartInfo, getProductsList, formatOmniCartResponse , getCookie, setVzdlPageInfo} from './utils';
import CustomEvent from 'custom-event';
import cloneDeep from 'lodash/cloneDeep';

window.redirectionExecuted = false;
export default function init() {
    if(!window.digitalData) {
        window.digitalData = cloneDeep(digitalData); 
    }
    if(!window.vzdl) {
        window.vzdl = cloneDeep(vzdl); 
    }
    // const tempFunc = window.newrelic.addPageAction;
    // window.newrelic.addPageAction = function() {
    //     console.log("newRelic Events", ...arguments);
    //     tempFunc(...arguments);
    // }
    if(window?.newrelic) {
        if(!window?.newrelic?.info?.jsAttributes?._cls_s) {
          const clss =  getCookie("_cls_s");
          const clsv =  getCookie("_cls_v");
          window.newrelic.setCustomAttribute("_cls_s", clss);
          window.newrelic.setCustomAttribute("_cls_v", clsv);
        }
      }
}
 
export function dispatchEvent(eventName, data) {
    const event = new CustomEvent(eventName, {
        detail: data
    });
    window.addEventListener('Virtual Page View',function (e) {
        console.log('Virtual Page View fired  '+ window['digitalData'].pageInfo.pageName);
    }); 
    window.addEventListener('Add To Cart',function (e) {
        console.log('Add To Cart fired ' + eventName);
    }); 
    window.dispatchEvent(event);
}

export function dispatchErrorEvent(data) {
    const event = new CustomEvent('Error', {
        detail: data
    });
    window.dispatchEvent(event);
}

export function trackPageInfo(pageName) {
    try {
        const pageInfo = setPageInfo(PageInfo);
        const vzdlPageInfo = setVzdlPageInfo(VzdlPageInfo);
        window.digitalData.pageInfo =  pageInfo;
        window.vzdl.page =  vzdlPageInfo;
        // window.digitalData.events = [];
       window.digitalData.events.push({eventName: "Virtual Page View", ...pageInfo});
        if(window._satellite) {
            // dispatchEvent('Page_Load_Complete', pageInfo);
            dispatchEvent('Virtual Page View', pageInfo);
        } else  {
            setTimeout(() => {
                // dispatchEvent('Page_Load_Complete', pageInfo);
                dispatchEvent('Virtual Page View', pageInfo);
            }, 1000);
        }
        if(window?.newrelic && window?.newrelic?.addPageAction ) {
            // window.newrelic.setPageViewName(pageName, window.location.href);
            window.newrelic.addPageAction(`${pageName} PageLoad complete`, {data: {pageName, location: window.location.href} });
        }
    } catch(err) {
        console.log(err);
    }
}

export function trackOrderStatus(orderStatus) {
    try {
        window.digitalData.pendingOrder = orderStatus ?  "Yes" : "No";
        window.digitalData.events.push({eventName: "Order_Status_Response", orderStatus});
        dispatchEvent('Order_Status_Response', orderStatus);
    } catch(err) {
        console.log(err)
    }
}

export function trackQualificationResponse( request, response) {
    try {
        let type = "";
        if(response) {
            if (response?.HasError) {
                type= 'out-of-franchise';
            }  else if (response?.RedirectToNextPage) {
                type= 'customize-order';
            } else if (response?.OOF) {
                type= 'out-of-franchise';
            } else if (response?.HasExistingService) {
                type= 'IS_EXISTING_CUSTOMER';
            } else if (response?.HasPendingOrder) {
                type= 'HAS_PENDING_ORDER';
            } else if (response?.HasMultipleAddress) {
                type= 'HAS_MULTIPLE_ADDRESS';
            } else if (response?.HasPendingOrder) {
                type= 'HAS_PENDING_ORDER';
            }
        }
   
        const qualifyForInternet = { 
            "Zipcode": request?.zipCode,
        "Qualifyresponse": {
                addressId: request?.AddressID,
                response,
                type
            },
        };
        window.digitalData.qualifyForInternet = qualifyForInternet;
        window.digitalData.events.push({eventName: "Qualification_Response", ...qualifyForInternet, request});
        dispatchEvent('Qualification_Response', qualifyForInternet);
    } catch(err) {
        console.log(err)
    }
}

export function trackSaveCart(cartInfoReq, cartInfoResponse) {
    try {
        const cartInfo = setSaveCartInfo(cartInfoReq, cartInfoResponse);
        window.digitalData.saveCart = cartInfo;
        const eventDataPayload = {eventName: "Save Cart Complete", eventPayload:{...cartInfo,sessionId:cartInfo?.other?.sessionId}};
        window.digitalData.events.push(eventDataPayload);
        dispatchEvent('Save Cart Complete', eventDataPayload);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('save_cart_complete', {data: cartInfo });
        }     
    } catch(err) {
        console.log(err)
    }
}

export function trackAddBundle(bundleInfo={}) {
    try {
        const bundle =   { 
            eventName: "Add Bundle",
            productType: bundleInfo?.bundleFlow,
            product: bundleInfo?.selectedPlanDetails
          }
        // window.digitalData.events.push(bundle);
        // dispatchEvent('addBundle', bundleInfo);
    } catch(err) {
        console.log(err)
    }
}

export function trackNonBundleFlow() {
    try {
        const nonBundleSelection = { 
            eventName: "Bundle Not Selected",
          };
        window.digitalData.events.push(nonBundleSelection);
        dispatchEvent('bundle_not_selected', nonBundleSelection);   
    } catch(err) {
        console.log(err)
    }
}

export function trackComponentLoad(componentName, products) {
    try {
        window.digitalData.pageInfo.componentName = componentName;
        if(products){
            if(products?.cartInfo) {
                const productsArr = formatCartInfo(products?.floatCartInfo);
                digitalData.shoppingCartInfo = {...products, productsArr}
            } else {
                window.digitalData.productsDisplayed = products;
            }
        } 
        dispatchEvent('component_load', componentName);   
    } catch(err) {
        console.log(err)
    }
}

export function trackCartClicked(cartInfo, floatCartInfo) {
    try {
        const productsArr = formatCartInfo(floatCartInfo);
        const cartDetails = {floatCartInfo, cartInfo, productsArr};
        window.digitalData.events.push({eventName: 'mini_cart_view', ...cartDetails});
        dispatchEvent('mini_cart_view', cartDetails);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('mini_cart_view', {data: cartDetails });
        }     
    } catch(err) {
        console.log(err)
    }
}

export function trackInternetSelection(productType, product) {
    try {
        const internetSelection = { 
            eventName: "Internet Service Added",
            productType,
            product
          };
        // window.digitalData.events.push(internetSelection);
        // dispatchEvent('Internet_Service_Selected', internetSelection);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Internet_Service_Selected', {data: internetSelection });
        }     
    } catch(err) {
        console.log(err)
    }
}

export function trackIPSelection(product) {
    try {
        if(product == "continueClick") {
            const IPSelection = window.digitalData?.lastSelection;
            window.digitalData.events.push(IPSelection);
            dispatchEvent('IP_Address_Selected', IPSelection);   
            if(window?.newrelic?.addPageAction) {
                window.newrelic.addPageAction('Router Added', {data: IPSelection });
            }     
        } else {
            let displayPrice = "0.00"
            if(product.PrdPrice != "INCLUDED") {
                displayPrice = "20.00"
            }
            const IPSelection  ={ 
                eventName: "IP_Address_Selected",
                product: {
                    ...product,
                    displayPrice: displayPrice
                }
            };
            window.digitalData.lastSelection = IPSelection;
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackEquipmentSelection(serviceType, payload) {
// commented few lines to avoid redundant events--> ref DAIF-7801
    try {
        if(serviceType == "continueClick") {
            const equipmentSelection = { 
                    eventName: "Router_Equipment_Selected",
                    product: {
                        serviceType,
                        ...payload,
                    }
                }
            // window.digitalData?.lastSelection;
            // window.digitalData.events.push({});
            // dispatchEvent('Equipment_Selected', equipmentSelection);   
            if(window?.newrelic?.addPageAction) {
                window.newrelic.addPageAction('Equipment_Selected', {data: equipmentSelection });
            }     
            
        } else {
            // const equipmentSelection  ={ 
            //     eventName: "Router_Equipment_Selected",
            //     product: {
            //         serviceType,
            //         ...payload,
            //     }
            // };
            //  window.digitalData.lastSelection = equipmentSelection;
        } 
    } catch(err) {
        console.log(err)
    }
}

export function trackInstallationSelection(product) {

    try {
        if(product == "continueClick") {
            const installationSelection = window.digitalData?.lastSelection;
            window.digitalData.events.push(installationSelection);
            dispatchEvent('Installation_Selected', installationSelection);   
        } else {
            const installationSelection  ={ 
                eventName: "Installation_Selected",
                product
            };
            window.digitalData.lastSelection = installationSelection;
        } 
    } catch(err) {
        console.log(err)
    }
}

export function trackSecureServiceSelection(product) { 
    try {
        if(product == "continueClick") {
            const securityOptionSelection = window.digitalData?.lastSelection;
            // window.digitalData.events.push(securityOptionSelection);
            // dispatchEvent('secure_service_selected', securityOptionSelection);   
        } else {

            if(window.digitalData.lastSelection && window.digitalData.lastSelection.eventName == "Security Service Added" ) {
                window.digitalData.lastSelection[product?.sectionName] = {
                    product,
                };
            } else  {
                const securityOptionSelection = {
                    eventName: "Security Service Added"
                };
                securityOptionSelection[product?.sectionName] = {
                    product,
                };
                window.digitalData.lastSelection = securityOptionSelection;
            }
        } 
    } catch(err) {
        console.log(err)
    }
}

export function trackPhoneServiceSelection(product, payload) {
    try {
        if(product == "continueClick") {
            const phoneSelection = window.digitalData?.lastSelection;
            // window.digitalData.events.push(phoneSelection);
            // dispatchEvent('phone_service_selected', phoneSelection);   
            if(window?.newrelic?.addPageAction) {
                window.newrelic.addPageAction('phone_service_selected', {data: phoneSelection });
            }     
        } else {
            const phoneSelection = { 
                eventName: "Phone Service Added",
                product: payload,
            };
            window.digitalData.lastSelection = phoneSelection;
        } 
    } catch(err) {
        console.log(err)
    }
}

export function trackPhoneLineAddition(selectedNumOfLines) {
    try {
        const phoneSelection = { 
            eventName: "Phone Line Added",
            selectedNumOfLines,
        }; 
       // window.digitalData.events.push(phoneSelection);
        //dispatchEvent('phone_line_added', phoneSelection);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('phone_line_added', {data: phoneSelection });
        }     
    } catch(err) {
        console.log(err)
    }
}

export function trackStandardPhoneLineSelection(product) {
    try {
        const phoneSelection = { 
            eventName: "Standard_Phoneline_Service",
            product,
        }; 
        window.digitalData.events.push(phoneSelection);
        dispatchEvent('Standard_Phoneline_Service', phoneSelection);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Standard_Phoneline_Service', {data: phoneSelection });
        }     
    } catch(err) {
        console.log(err)
    }
}

export function trackPhoneEquipmentAddition(products) {
    try {
        const phoneEquipSelection = { 
            eventName: "Phone Equipment Added",
            products,
        }; 
        window.digitalData.events.push(phoneEquipSelection);
        dispatchEvent('phone_equipment_add', phoneEquipSelection);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('phone_equipment_add', {data: phoneEquipSelection });
        }     
    } catch(err) {
        console.log(err)
    }
}

export function trackDirectorySeletion(product) {
    try {
        const directorySelections = { 
            eventName: "Directory Listing Selected",
            product
        };
        window.digitalData.events.push(directorySelections);
        dispatchEvent('Directory_listing_selected', directorySelections);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Directory_listing_selected', {data: directorySelections });
        }     
    } catch(err) {
        console.log(err)
    }
}
export function trackPowerBackupSel(payload) {
    try {
        const pbSelections = { 
            eventName: "Power Backup Selected",
            product: payload
        };
        window.digitalData.events.push(pbSelections);
        dispatchEvent('Power_Backup_selected', pbSelections);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Power_Backup_selected', {data: pbSelections });
        }     
    } catch(err) {
        console.log(err)
    }
}


export function trackTVServiceSeletion(payload) {
    try {
        const tvSelection = { 
            eventName: "Add TV Services",
            productType: "TV Service",
            product: payload
          }
        // window.digitalData.events.push(tvSelection);
        // dispatchEvent('add_tv_services', tvSelection);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('add_tv_services', {data: tvSelection });
        }  
    } catch(err) {
        console.log(err)
    }
}

export function trackTVRecordings(payload) {
    try {
        const tvSelection = { 
            eventName: "Add TV Recordinga",
            productType: "TV Recordings",
            product: payload
          }
        // window.digitalData.events.push(tvSelection);
        // dispatchEvent('add_tv_recording', tvSelection);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('add_tv_recording', {data: tvSelection });
        }  
    } catch(err) {
        console.log(err)
    }
}

export function trackTVPlanAddition(payload) {
    try {
        const tvSelection = { 
            eventName: "Add TV Plan",
            productType: "TV Plans",
            product: payload
          }
        // window.digitalData.events.push(tvSelection);
        // dispatchEvent('add_tv_plan', tvSelection);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('add_tv_plan', {data: tvSelection });
        }  
    } catch(err) {
        console.log(err)
    }
};

export function trackTVEquipSelection(payload) {
    try {
        const tvSelection = { 
            eventName: "Add TV Equipments",
            productType: "TV Equipments",
            product: payload
          }
        // window.digitalData.events.push(tvSelection);
        // dispatchEvent('add_tv_equipment', tvSelection);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('add_tv_equipment', {data: tvSelection });
        }  
    } catch(err) {
        console.log(err)
    }
}

export function trackPreimChannelSelection(payload) {
    try {
        const tvSelection = { 
            eventName: "Add TV Premium Channel",
            productType: "Premium Channels",
            product: payload
          }
        // window.digitalData.events.push(tvSelection);
        // dispatchEvent('add_tv_PremiumSelection', tvSelection);   
    } catch(err) {
        console.log(err)
    }
}

export function trackSupportServiceSeletion(payload) {
    try {
        const supportSelection = { 
            eventName: "Support Services Selected",
            productType: " Maintainence and Support", 
            product: payload,
          }
        // window.digitalData.events.push(supportSelection);
        // dispatchEvent('support_service_selected', supportSelection);   
    } catch(err) {
        console.log(err)
    }
}

export function trackContractSeletion(payload) {
    try {
        const contractSelection = { 
            eventName: "Contract Agreement Selected",
            productType: "Contract Agreement", 
            product: payload
          };
        window.digitalData.events.push(contractSelection);
        dispatchEvent('contract_agreement_selected', contractSelection); 
    } catch(err) {
        console.log(err)
    }
}

 export function trackFormInitSeletion(cartInfo={}) {
    try {
        const eventObj = { 
            eventName: "Business Information Form Initiate",
        };
        const productsArr = formatCartInfo(cartInfo?.floatCartInfo);
        window.digitalData.shoppingCartInfo = {...cartInfo, productsArr}
        window.digitalData.events.push(eventObj);
        dispatchEvent('BI_form_initiate', eventObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('BI_form_initiate', {data: eventObj });
        }  
    } catch(err) {
        console.log(err)
    }
}

export function trackBIFormComplete(cartInfo={}) {
    try {
        const eventObj = { 
            eventName: "Business Information Form Complete"
        };
        const productsArr = formatCartInfo(cartInfo?.floatCartInfo);
        window.digitalData.shoppingCartInfo = {...cartInfo, productsArr}
        window.digitalData.events.push(eventObj);
        dispatchEvent('BI_Form_Complete', eventObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('BI_Form_Complete', {data: eventObj });
        }  
    } catch(err) {
        console.log(err)
    }
}

export function trackCCFormInit(cartInfo={}) {
    try {
        const eventObj = { 
            eventName: "Credit Check Form Initiate"
        };
        const productsArr = formatCartInfo(cartInfo?.floatCartInfo);
        window.digitalData.shoppingCartInfo = {...cartInfo, productsArr}
        window.digitalData.events.push(eventObj);
        dispatchEvent('cc_form_initiate', eventObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('cc_form_initiate', {data: eventObj });
        }  
    } catch(err) {
        console.log(err)
    }
}

export function trackCCFormComplete(cartInfo={}) {
    try {
        const eventObj = { 
            eventName: "Credit Check Form Complete"
        };
        const productsArr = formatCartInfo(cartInfo?.floatCartInfo);
        window.digitalData.shoppingCartInfo = {...cartInfo, productsArr}
        window.digitalData.events.push(eventObj);
        dispatchEvent('cc_form_complete', eventObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('cc_form_complete', {data: eventObj });
        }  
    } catch(err) {
        console.log(err)
    }
}

export function trackCCStatus(payload={}) {
    try {
        const eventObj = { 
            eventName: "Credit Check Status",
            response: payload
        };
        window.digitalData.events.push(eventObj); 
        dispatchEvent('cc_status', eventObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('cc_status', {data: eventObj });
        }  
    } catch(err) {
        console.log(err)
    }
}

export function trackPaymentSelection(payload={}, cartInfo={}) {
    try {
        const eventObj ={ 
            eventName: "Payment Method Selected",
            eventdetails: payload
        };
        const productsArr = formatCartInfo(cartInfo?.floatCartInfo);
        window.digitalData.shoppingCartInfo = {...cartInfo, productsArr}
        window.digitalData.events.push(eventObj);
        dispatchEvent('payment_method_selected', eventObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('payment_method_selected', {data: eventObj });
        }  
    } catch(err) {
        console.log(err)
    }
}

export function trackInstallationSetupSelection(payload={}) {
    try {
        const eventObj ={ 
            eventName: "Installation Date and Time Selected",
            eventdetails: payload
        };
        window.digitalData.events.push(eventObj);
        dispatchEvent('installation_date_selected', eventObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('installation_date_selected', {data: eventObj });
        }  
    } catch(err) {
        console.log(err)
    }
}

export function trackOrderConfirmation(payload={}) {
    try {
        const cartSummary= window.digitalData.cartSummary || {};
        let productsArr = [];
        if(payload.floatCartInfo) {
            productsArr  = formatCartInfo(payload?.floatCartInfo);
            window.digitalData.shoppingCartInfo = { floatCartInfo: payload?.floatCartInfo, cartInfo: payload?.cartInfo, productsArr}
        } 
        const orderConf = { 
            eventName: "Order_Confirmation",
            order: payload,
            productsArr,
            ...cartSummary
        };
        const otherServices = payload?.floatCartInfo?.planDetails?.otherServices;
        if(otherServices) {
            const techTeamProduct = otherServices.filter( service => {
                return service?.Product?.toLowerCase()?.indexOf('techteam') > -1;
            })
            if(techTeamProduct && techTeamProduct[0])
            trackTechTeamOrderConfirmation(techTeamProduct[0]);
        }
        window.digitalData.transactionInfo = orderConf;
        if(window.digitalData?.events?.length > 2 ) {
            window.digitalData.events.push(orderConf);
            dispatchEvent('Order_Confirmation', orderConf);   
            if(window?.newrelic?.addPageAction) {
                window.newrelic.addPageAction('Order_Confirmation', {data: orderConf });
            }  
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackOrderFailure() {
    try {
        const orderFailure = { 
            eventName: "Order_Submit_Failure"
        };
        window.digitalData.events.push(orderFailure);
        dispatchEvent('Order_Submit_Failure'); 
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Order_Submit_Failure', {data: orderFailure });
        }   
    } catch(err) {
        console.log(err)
    }
}

export function trackCartRemoval(payload) {
    dispatchEvent('cart_remove', payload);   
}

export function trackCartSummaryPrice(payload) {
    const currentCart = window.digitalData?.cartSummary || {}
    window.digitalData.cartSummary = {
        ...currentCart,
        ...payload
    };
} 

export function trackProductsList(NonDoRes={}) {
    try {
        const qualifiedServicesList = { 
            eventName: "Qualified_Services_List",
            data:  getProductsList(NonDoRes.LQPost)
        };
        window.digitalData.qualifiedServices = getProductsList(NonDoRes?.LQPost);
        window.digitalData.events.push(qualifiedServicesList);
        dispatchEvent('Qualified_Services_List', qualifiedServicesList);  
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Qualified_Services_List', {data: qualifiedServicesList });
        }   
    } catch(err) {
        console.log(err)
    }
}

export function trackCheckoutProdSelection(floatCartInfo) {
    try {
        const productsArr = formatCartInfo(floatCartInfo);
        window.digitalData.shoppingCartInfo = {floatCartInfo, productsArr}
        window.digitalData.events.push({eventName: 'checkout_products_list', productsArr});
        dispatchEvent('checkout_products_list', productsArr);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('checkout_products_list', {data: productsArr });
        }   
    } catch(err) {
        console.log(err)
    }
}


export function trackInstallmentsInitiate() {
    try {
        const PFBObj = { 
            eventName: "Installments and Payments Method Initiate",
        };
        window.digitalData.events.push(PFBObj);
        dispatchEvent('installments_and_payments_method_initiate', PFBObj);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('installments_and_payments_method_initiate', {data: PFBObj });
        }   
    } catch(err) {
        console.log(err)
    }
}

export function trackInstallmentsComplete() {
    try {
        const PFBObj = { 
            eventName: "Installments and Payments Method Complete",
        };
        window.digitalData.events.push(PFBObj);
        dispatchEvent('installments_and_payments_method_complete', PFBObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('installments_and_payments_method_complete', {data: PFBObj });
        }
    } catch(err) {
        console.log(err)
    }
}
export function trackInstallationInitiate() {
    try {
        const PFBObj = { 
            eventName: "Installation Time – Opened",
        };
        window.digitalData.events.push(PFBObj);
        dispatchEvent('installation_time_opened', PFBObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('installation_time_opened', {data: PFBObj });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackInstallationComplete() {
    try {
        const PFBObj = { 
            eventName: "Installation Time – Complete",
        };
        window.digitalData.events.push(PFBObj);
        dispatchEvent('installation_time_complete', PFBObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('installation_time_complete', {data: PFBObj });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackDepositInitiate() {
    try {
        const PFBObj = { 
            eventName: "Deposit – Opened",
        };
        window.digitalData.events.push(PFBObj);
        dispatchEvent('deposit_opened', PFBObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('deposit_complete', {data: PFBObj });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackDepositComplete() {
    try {
        const PFBObj = { 
            eventName: "Deposit – Complete",
        };
        window.digitalData.events.push(PFBObj);
        dispatchEvent('deposit_complete', PFBObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('deposit_complete', {data: PFBObj });
        }
    } catch(err) {
        console.log(err)
    }
}


export function trackPaperFreeBillingStatus(selection) {
    try {
        const PFBObj = { 
            eventName: "Paper Free Billing Selection",
            selection,
        };
        window.digitalData.events.push(PFBObj);
        dispatchEvent('paperfreebilling_status', PFBObj);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('paperfreebilling_status', {data: PFBObj });
        }
    } catch(err) {
        console.log(err)
    }
}


export function trackTOSOpen() {
    try {
        const TOSObj = { 
            eventName: "Terms of Service – Open",
        };
        window.digitalData.events.push(TOSObj);
        dispatchEvent('termsofservice_open', TOSObj);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('termsofservice_open', {data: TOSObj });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackChatId(id) {
    try {
        const ChatIdObj = { 
            eventName: "Chat Initiated – Id",
            id,
        };
        window.digitalData.events.push(ChatIdObj);
        dispatchEvent('chat_id', ChatIdObj);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('chat_id', {data: ChatIdObj });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackTOSComplete() {
    try {
        const TOSObj = { 
            eventName: "Terms of Service – Complete",
        };
        window.digitalData.events.push(TOSObj);
        dispatchEvent('termsofservice_complete', TOSObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('termsofservice_complete', {data: TOSObj });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackTOSAccordianOpen() {
    try {
        const TOSObj = { 
            eventName: "Terms of Service accordian – Open",
        };
        window.digitalData.events.push(TOSObj);
        dispatchEvent('termsofservice_accordian_open', TOSObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('termsofservice_accordian_open', {data: TOSObj });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackTOSAccordianComplete() {
    try {
        const TOSObj = { 
            eventName: "Terms of Service accordian – Complete",
        };
        window.digitalData.events.push(TOSObj);
        dispatchEvent('termsofservice_accordian_complete', TOSObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('termsofservice_accordian_complete', {data: TOSObj });
        }
    } catch(err) {
        console.log(err)
    }
}

function validateLQPostFlag(data) {
    let flag = false;
    if(data && (data === 'Y' || data === 'true')) {
        flag = true;
    }
    return flag;
}

export function trackLQAttempts( request, response) {
    try {
        let type = "";
        if(response) {
            if (response?.HasError) {
                type= 'out-of-franchise';
            }  else if (response?.RedirectToNextPage) {
                type= 'customize-order';
            } else if (response?.OOF) {
                type= 'out-of-franchise';
            } else if (response?.HasExistingService) {
                type= 'IS_EXISTING_CUSTOMER';
            } else if (response?.HasPendingOrder) {
                type= 'HAS_PENDING_ORDER';
            } else if (response?.HasMultipleAddress) {
                type= 'HAS_MULTIPLE_ADDRESS';
            } else if (response?.HasPendingOrder) {
                type= 'HAS_PENDING_ORDER';
            }
        }
       let qiPayload ={eventName: "LQ_Attempts",eventPayload:{}};
        const qualifyForInternet = { 
            "Zipcode": request?.zipCode,
           "Qualifyresponse": {
                addressId: request?.AddressID,
                locusID:request?.BaselocationId,
                sublocationId:request?.SublocationId,
                response,
                type
            },
            qualifiedServicesList: getProductsList(response?.data?.LQPost || {}),
            type: '',//'fios-landing',
          	"addressId": response?.data?.AddressId,
            "locusID":request?.BaselocationId,
            "sublocationId":request?.SublocationId,
            "response": {
                "type": "",
                "data": {
                    "sessionId": response?.data?.LQPost?.EPSessionID,
                    "Qualified_4g": validateLQPostFlag(response?.data?.Qualified_4g) || true,
                    "Qualified4GHome": validateLQPostFlag(response?.data?.Qualified4GHome)|| true,
                    "QualifiedCBand": validateLQPostFlag(response?.data?.QualifiedCBand),
                    "QualifiedHSI": validateLQPostFlag(response?.data?.LQPost?.HSIStatus),
                    "Qualified_5g": validateLQPostFlag(response?.data?.QualifiedCBand),
                    "Qualified5GHome": validateLQPostFlag(response?.data?.QualifiedCBand),
                    "QualifiedLTE": validateLQPostFlag(response?.data?.Qualified_4g) || true,
                    "QualifiedFIOS": validateLQPostFlag(response?.data?.LQPost?.FiOSDataStatus),
                    "Qualified_5gMww": false,
                }
            },
            "entrypoint": '',//document.referrer
        };
        window.digitalData.qualifyForInternet = qualifyForInternet;
        qiPayload.eventPayload = {...qualifyForInternet, request};
        window.digitalData.events.push(qiPayload);
        dispatchEvent('LQ_Attempts', qiPayload);
    } catch(err) {
        console.log(err)
    }
}

export function trackLQSuccess( request, response) {
    try {
        let type = "";
        if(response) {
            if (response?.HasError) {
                type= 'out-of-franchise';
            }  else if (response?.RedirectToNextPage) {
                type= 'customize-order';
            } else if (response?.OOF) {
                type= 'out-of-franchise';
            } else if (response?.HasExistingService) {
                type= 'IS_EXISTING_CUSTOMER';
            } else if (response?.HasPendingOrder) {
                type= 'HAS_PENDING_ORDER';
            } else if (response?.HasMultipleAddress) {
                type= 'HAS_MULTIPLE_ADDRESS';
            } else if (response?.HasPendingOrder) {
                type= 'HAS_PENDING_ORDER';
            }
        }
        let qiPayload ={eventName: "LQ_Success",eventPayload:{}};
        const qualifyForInternet = { 
            "Zipcode": request?.zipCode,
           "Qualifyresponse": {
                addressId: request?.AddressID,
                locusID:request?.BaselocationId,
                sublocationId:request?.SublocationId,
                response,
                type
            },
            qualifiedServicesList: getProductsList(response?.data?.LQPost || {}),
            reqType: '',//'fios-landing',
            type: '',//'fios-landing',
            "addressId": response?.data?.AddressId,
            "locusID":request?.BaselocationId,
            "sublocationId":request?.SublocationId,
            "response": {
                "type": "",
                "data": {
                    "sessionId": response?.data?.LQPost?.EPSessionID,
                    "Qualified_4g": validateLQPostFlag(response?.data?.Qualified_4g) || true,
                    "Qualified4GHome": validateLQPostFlag(response?.data?.Qualified4GHome) || true,
                    "QualifiedCBand": validateLQPostFlag(response?.data?.QualifiedCBand),
                    "QualifiedHSI": validateLQPostFlag(response?.data?.LQPost?.HSIStatus),
                    "Qualified_5g": validateLQPostFlag(response?.data?.QualifiedCBand),
                    "Qualified5GHome": validateLQPostFlag(response?.data?.QualifiedCBand),
                    "QualifiedLTE": validateLQPostFlag(response?.data?.Qualified_4g) || true,
                    "QualifiedFIOS": validateLQPostFlag(response?.data?.LQPost?.FiOSDataStatus),
                    "Qualified_5gMww": validateLQPostFlag(response?.data?.Qualified),
                }
            },
            "entrypoint": '',//document.referrer
        };
        window.digitalData.qualifyForInternet = qualifyForInternet;
        qiPayload.eventPayload = {...qualifyForInternet, request};
        window.digitalData.events.push(qiPayload);
        dispatchEvent('LQ_Success', qiPayload);
    } catch(err) {
        console.log(err)
    }
}

export function trackLQFailure( request, response) {
    try {
        let type = "";
        if(response) {
            if (response?.HasError) {
                type= 'out-of-franchise';
            }  else if (response?.RedirectToNextPage) {
                type= 'customize-order';
            } else if (response?.OOF) {
                type= 'out-of-franchise';
            } else if (response?.HasExistingService) {
                type= 'IS_EXISTING_CUSTOMER';
            } else if (response?.HasPendingOrder) {
                type= 'HAS_PENDING_ORDER';
            } else if (response?.HasMultipleAddress) {
                type= 'HAS_MULTIPLE_ADDRESS';
            } else if (response?.HasPendingOrder) {
                type= 'HAS_PENDING_ORDER';
            }
        }
       
        const qualifyForInternet = { 
            "Zipcode": request?.zipCode,
           "Qualifyresponse": {
                addressId: request?.AddressID,
                response,
                type
            },
        };
        window.digitalData.qualifyForInternet = qualifyForInternet;
        window.digitalData.events.push({eventName: "LQ_Failure", ...qualifyForInternet, request});
        dispatchEvent('LQ_Failure', qualifyForInternet);
    } catch(err) {
        console.log(err)
    }
}

export function trackOptixBusinessFormInit() {
    try {
        const eventObj = { 
            eventName: "Business Information Form Initiate",
        };
        window.digitalData.events.push(eventObj);
        dispatchEvent('BI_form_initiate', eventObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('BI_form_initiate', {data: eventObj });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackOptixBIFormComplete() {
    try {
        const eventObj = { 
            eventName: "Business Information Form Complete"
        };
        window.digitalData.events.push(eventObj);
        dispatchEvent('BI_Form_Complete', eventObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('BI_Form_Complete', {data: eventObj });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackOptixCCFormInit() {
    try {
        const eventObj = { 
            eventName: "Credit Check Form Initiate"
        };
        window.digitalData.events.push(eventObj);
        dispatchEvent('cc_form_initiate', eventObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('cc_form_initiate', {data: eventObj });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackOptixCCFormComplete() {
    try {
        const eventObj = { 
            eventName: "Credit Check Form Complete"
        };
        window.digitalData.events.push(eventObj);
        dispatchEvent('cc_form_complete', eventObj);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('cc_form_complete', {data: eventObj });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackOmniCheckoutProdSelection(getOmniCartInfoSuccessResponse) {
    try {
        if(getOmniCartInfoSuccessResponse) {
            const cartSummary = getOmniCartInfoSuccessResponse?.TotalChargesWithDiscount;
            window.digitalData.cartSummary = cartSummary;
            const productsArr = formatOmniCartResponse(getOmniCartInfoSuccessResponse);
            window.digitalData.shoppingCartInfo = { productsArr, cartSummary };
            window.digitalData.events.push({eventName: 'checkout_products_list', productsArr});
            dispatchEvent('checkout_products_list', productsArr);   
            if(window?.newrelic?.addPageAction) {
                window.newrelic.addPageAction('checkout_products_list', {data: productsArr });
            }
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackLQPageSelectedQuoteOption(eventName) {
    try {
        const eventObj = { 
            eventName: "lq_page_optix_radio_button_selection",
            selectedButton: eventName
        };
        window.digitalData.events.push(eventObj);
        dispatchEvent('lq_page_optix_radio_button_selection', eventObj);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Existing Customer Continue Button Click', {data: {eventName: "LQ Continue"} });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackOptixQuoteNumber(optixQuoteNumber) {
    try {
        const eventObj = { 
            eventName: "optix quote number saved",
        };
    
        const quoteNumber = optixQuoteNumber ? optixQuoteNumber : window.sessionStorage.getItem('optixQuoteNum');
        window.digitalData.visitorProfile.optixQuoteNum = quoteNumber;
    
        if(optixQuoteNumber) {
            window.digitalData.events.push(eventObj);
            dispatchEvent('optix_quote_number_saved', eventObj);
            if(window?.newrelic?.addPageAction) {
                window.newrelic.addPageAction('Quote Number Saved', {data: {quoteNumber} });
            }
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackOptixOrderConfirmation(payload) {
    try {
        const cartSummary= window.digitalData?.cartSummary || {};
        const shoppingCartInfo = window.digitalData?.shoppingCartInfo || {};
        const productsArr = shoppingCartInfo && shoppingCartInfo.productsArr ? shoppingCartInfo.productsArr : [];
    
        const orderConf = { 
            eventName: "Order_Confirmation",
            order: payload,
            productsArr,
            cartSummary
        };
    
        window.digitalData.transactionInfo = orderConf;
        window.digitalData.events.push(orderConf);
        dispatchEvent('Order_Confirmation', orderConf); 
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Order_Confirmation', {data: orderConf });
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackCheckoutBtnClick() {
    try {
        const btnClick = { 
            eventName: "Checkout Button Click",
          };
        window.digitalData.events.push(btnClick);
        dispatchEvent('checkout_button_click', btnClick);   
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Checkout Button Click', {data: {eventName: 'checkout_button_click'} });     
        }
    } catch(err) {
        console.log(err)
    }
}
export function trackTechTeamProductSelection(product) {
    try {
        const eventObj = { 
            eventName: "TechTeam_Product_Selection",
            productInfo: {
                productName:product?.ProductName,
                productPrice:product?.Price,
                productQty:'',
                productId: product?.ProductId,
                productType:'Tech Team for Internet',
            }
          };
        window.digitalData.events.push(eventObj);
        dispatchEvent('TechTeam_Product_Selection', eventObj);  
        if(window?.newrelic?.addPageAction) { 
            window.newrelic.addPageAction('TechTeam_Product_Selection', {data: {eventName: 'TechTeam_Product_Selection', product} });     
        }
    } catch(err) {
        console.log(err)
    }
}
 
export function trackTechTeamOrderConfirmation(productInfo) {
    try {
        const eventObj = { 
            eventName: "TechTeamOrderConfirmation", 
            productInfo: {
                productName:productInfo?.Product,
                productPrice:productInfo?.price,
            }
          };
        window.digitalData.events.push(eventObj);
        dispatchEvent('TechTeamOrderConfirmation', eventObj);  
        if(window?.newrelic?.addPageAction) {  
            window.newrelic.addPageAction('TechTeamOrderConfirmation', {data: {eventName: 'TechTeamOrderConfirmation', productInfo} });     
        }
    } catch(err) {
        console.log(err)
    }
}

export function trackLQSuccess5G( request, response) {
    try {
        
        const qualifyForInternet = { 
            "Zipcode": request?.zipCode,
           "Qualifyresponse": {
                addressId: request?.AddressID,
                response, 
            },
            qualifiedServicesList: getProductsList(response?.data?.LQPost || {})
        };
        window.digitalData.qualifyForInternet = qualifyForInternet;
        window.digitalData.events.push({eventName: "LQ_Success_5G", ...qualifyForInternet, request});
        dispatchEvent('LQ_Success_5G', qualifyForInternet);
    } catch(err) {
        console.log(err)
    }
}
export function trackLQSuccess4G( request, response) {
    try { 
        const qualifyForInternet = { 
            "Zipcode": request?.zipCode,
           "Qualifyresponse": {
                addressId: request?.AddressID,
                response, 
            },
            qualifiedServicesList: getProductsList(response?.data?.LQPost || {})
        };
        window.digitalData.qualifyForInternet = qualifyForInternet;
        window.digitalData.events.push({eventName: "LQ_Success_4G", ...qualifyForInternet, request});
        dispatchEvent('LQ_Success_4G', qualifyForInternet);
    } catch(err) {
        console.log(err)
    }
}

export function track5GEligibleRedirection() {
    const btnClick = { 
        eventName: "5G_Eligible_Redirection",
      };
    window.digitalData.events.push(btnClick);
    dispatchEvent('5G_Eligible_Redirection', btnClick);   
    if(window?.newrelic?.addPageAction) {
        window.newrelic.addPageAction('5G_Eligible_Redirection', {data: {eventName: '5G_Eligible_Redirection'} });
    }
}
export function track4GEligibleRedirection() {
    const btnClick = { 
        eventName: "4G_Eligible_Redirection",
      };
    window.digitalData.events.push(btnClick);
    dispatchEvent('4G_Eligible_Redirection', btnClick);   
    if(window?.newrelic?.addPageAction) {
        window.newrelic.addPageAction('4G_Eligible_Redirection', {data: {eventName: '4G_Eligible_Redirection'} });
    }
}

export function trackAbandonedCartLanding(queryParams) {
    try{ 
        const btnClick = { 
            eventName: "Abandoned_Cart_Landing",
            queryParams
          };
        window.digitalData.events.push(btnClick);
        setTimeout(()=>{
            dispatchEvent('Abandoned_Cart_Landing', btnClick);   
        }, 10000); 
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Abandoned_Cart_Landing', {data: {eventName: 'Abandoned_Cart_Landing',queryParams} });
        }
    } catch(err) {
        console.log(err);
    }
}
export function trackFiosAPILanding(queryParams) {
    try{
        const btnClick = { 
            eventName: "Fios_API_Landing",
            queryParams
          };
       window.digitalData.events.push(btnClick);
        setTimeout(()=>{
            dispatchEvent('Fios_API_Landing', btnClick);   
            const attemptData =  {
                eventName: "LQ_Attempts",
                eventPayload:{
                    reqType: 'external',
                    source: document.referrer,
                    type: '', //fios-landing
                    "addressId": "",
                    "response": {
                        "type": "",
                        "data": {
                            "sessionId": "",
                            "Qualified_4g":  true,
                            "Qualified4GHome":  true,
                            "QualifiedCBand": false,
                            "QualifiedHSI":  false,
                            "Qualified_5g":  false,
                            "Qualified5GHome": false,
                            "Qualified_5gMww": false,
                            "QualifiedLTE":  true,
                            "QualifiedFIOS": true,
                        }
                    },
                "entrypoint": '',//document.referrer
                }
            };
            const successData =  {
                eventName: "LQ_Success",
                eventPayload: {
                reqType: 'external',
				source: document.referrer, 
                type: '', //fios-landing
                "addressId": "",
                "response": {
                    "type": "",
                    "data": {
                        "sessionId": "",
                        "Qualified_4g":  true,
                        "Qualified4GHome": true,
                        "QualifiedCBand": false,
                        "QualifiedHSI":  false,
                        "Qualified_5g":  false,
                        "Qualified_5gMww": false,
                        "Qualified5GHome": false,
                        "QualifiedLTE":  true,
                        "QualifiedFIOS": true,
                    }
                },
                "entrypoint": '',//document.referrer
            } 
            };
            dispatchEvent('LQ_Attempts', attemptData);
            dispatchEvent('LQ_Success', successData);
            window.digitalData.events.push(attemptData);
            window.digitalData.events.push(successData);
        }, 7000);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Fios_API_Landing', {data: {eventName: 'Fios_API_Landing', queryParams} });
        }
    } catch(err) {
        console.log(err);
    }
}
export function trackRetrieveSaveLanding(queryParams) {
    try{
        const btnClick = { 
            eventName: "Retrieve_SaveCart_Landing",
            queryParams
          };
            window.digitalData.events.push(btnClick);
        setTimeout(()=>{
            dispatchEvent('Retrieve_SaveCart_Landing', btnClick);   
        }, 10000);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Retrieve_SaveCart_Landing', {data: {eventName: 'Retrieve_SaveCart_Landing', queryParams} });
        }
    } catch(err) {
        console.log(err);
    }
}
export function trackSMBBannerLanding(queryParams) {
    try{
        const btnClick = { 
            eventName: "SMB_Banner_Landing",
            queryParams
          };
        window.digitalData.events.push(btnClick);
        setTimeout(()=>{
            dispatchEvent('SMB_Banner_Landing', btnClick);   
        }, 10000);
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('SMB_Banner_Landing', {data: {eventName: 'SMB_Banner_Landing', queryParams} });
        }
    } catch(err) {
        console.log(err);
    }
}
export function trackWirelessOrderNowClick() {
    try{
        const btnClick = { 
            eventName: "Wireless_OrderNow_Btn_Click",
        };
        window.digitalData.events.push(btnClick); 
        dispatchEvent('Wireless_OrderNow_Btn_Click', btnClick); 
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('Wireless_OrderNow_Btn_Click', {data: btnClick });
        }
    } catch(err) {
        console.log(err);
    }
}

export function trackFiosSavedCartOffers(isOfferApplied) {
    try{
        const offerInfo = { 
            eventName: "FIOS_SavedCart_Offers",
            isOfferApplied
        };
        window.digitalData.events.push(offerInfo); 
        dispatchEvent('FIOS_SavedCart_Offers', offerInfo); 
        if(window?.newrelic?.addPageAction) {
            window.newrelic.addPageAction('FIOS_SavedCart_Offers', {data: offerInfo });
        }
    } catch(err) {
        console.log(err);
    }
}

export function formatAddToCartResponse(product){
    const productArray = [];
    const productInfo = {
        "productInfo":{
            productName: product?.productName,
            productPrice: product?.productPrice,
            productCategory: product?.productCategory,
            productId: product?.productId,
            productType: product?.productType
        }
    }
    productArray.push(productInfo);
    // let data = { eventName: "Add To Cart",eventPayload: {productArray}};

    return productArray;
}

export function trackAddToCart({productName,productId,productPrice,productType,productCategory}){
      const productInfo = {productName,productId,productPrice,productType,productCategory}
      const data = formatAddToCartResponse(productInfo);
      let productArraydata = { eventName: "Add To Cart",eventPayload: {
        productsArray:data
      }};
      dispatchEvent(productArraydata.eventName, productArraydata);
      window.digitalData.events.push(productArraydata);
}